import React from "react";

const DownloadIcon = ({
  color = "#259FA5",
  style
}: {
  color: string | undefined;
  style: any;
}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M11.0938 2.34375C11.0938 1.73877 10.605 1.25 10 1.25C9.39502 1.25 8.90625 1.73877 8.90625 2.34375V10.6392L6.39746 8.13037C5.97021 7.70312 5.27637 7.70312 4.84912 8.13037C4.42188 8.55762 4.42188 9.25146 4.84912 9.67871L9.22412 14.0537C9.65137 14.481 10.3452 14.481 10.7725 14.0537L15.1475 9.67871C15.5747 9.25146 15.5747 8.55762 15.1475 8.13037C14.7202 7.70312 14.0264 7.70312 13.5991 8.13037L11.0938 10.6392V2.34375ZM3.4375 13.2812C2.23096 13.2812 1.25 14.2622 1.25 15.4688V16.5625C1.25 17.769 2.23096 18.75 3.4375 18.75H16.5625C17.769 18.75 18.75 17.769 18.75 16.5625V15.4688C18.75 14.2622 17.769 13.2812 16.5625 13.2812H13.0933L11.5449 14.8296C10.6904 15.6841 9.30615 15.6841 8.45166 14.8296L6.90674 13.2812H3.4375ZM16.0156 15.1953C16.2332 15.1953 16.4418 15.2817 16.5957 15.4356C16.7495 15.5894 16.8359 15.7981 16.8359 16.0156C16.8359 16.2332 16.7495 16.4418 16.5957 16.5957C16.4418 16.7495 16.2332 16.8359 16.0156 16.8359C15.7981 16.8359 15.5894 16.7495 15.4356 16.5957C15.2817 16.4418 15.1953 16.2332 15.1953 16.0156C15.1953 15.7981 15.2817 15.5894 15.4356 15.4356C15.5894 15.2817 15.7981 15.1953 16.0156 15.1953Z"
        fill={color}
      />
    </svg>
  );
};
export default DownloadIcon;
